<div class="heroBanner bgPrimary">
    <div class="container">
        <h1 class="colorWhite text-center">Ways To Get Involved</h1>
    </div>
    
</div>

<div class="bgWhite py-80">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
                <div class="coursePart mb-3 h-100">
                    <h2 class="colorWhite mt-2 mb-4">Ministry Opportunities</h2>
                    <div class="list">
                        <ul>
                            <li>
                                <span><img src="./../../../assets/images/icguitar.png" class="img-fluid" /></span>Praise & Worship
                            </li>
                            <li>
                                <span><img src="./../../../assets/images/icvideo.png" class="img-fluid" /></span>Audio/Video
                            </li>
                            <li>
                                <span><img src="./../../../assets/images/icChildren.png" class="img-fluid" /></span>Children's Outreach
                            </li>
                            <li>
                                <span><img src="./../../../assets/images/icgames.png" class="img-fluid" /></span>Youth
                            </li>
                            <li>
                                <span><img src="./../../../assets/images/icGroup.png" class="img-fluid" /></span>Young Adults
                            </li>
                            <li>
                                <span><img src="./../../../assets/images/icYoung.png" class="img-fluid" /></span>Discipleship Group (iTIM) 
                            </li>
                            <li>
                                <span>
                                    <i class="fa-solid fa-box-open "></i>
                                </span>Food Bank
                            </li>
                            <li>
                                <span>
                                    <i class="fa-solid fa-earth-americas"></i>
                                </span>Global Missions
                            </li>
                            <li>
                                <span>
                                    <i class="fa-solid fa-person "></i>
                                </span>Men’s Counseling
                            </li>
                            <li>
                                <span>
                                    <i class="fa-solid fa-person-dress"></i>
                                </span>Women’s Counseling
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 col-lg-8 mb-3 mb-lg-0">
                <div class="coursePart mb-3 h-100">
                    <h2 class="colorWhite mt-2 mb-4" *ngIf="!submitted">Connect with Us!</h2>
                        <form *ngIf="!submitted" [formGroup]="eventForm" (ngSubmit)="handleConnect()">
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" class="form-control input" formControlName="name"
                                    [class.is-invalid]="isControlInvalid('name')" [class.is-valid]="isControlValid('name')">
                                <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                                    This field is required</h5>
                            </div>
                            
                            <div class="form-group">
                                <label>Email</label>
                                <input type="text" class="form-control input" formControlName="email"
                                    [class.is-invalid]="isControlInvalid('email')" [class.is-valid]="isControlValid('email')">
                                <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'email')">
                                    This field is required</h5>
                                <h5 class="invalid-feedback" *ngIf="controlHasError('pattern', 'email')">
                                    Please enter valid email address</h5>        
                            </div>
                            
                            <div class="form-group">
                                <label>Phone</label>
                                <input type="text" class="form-control input" formControlName="phone"
                                    [class.is-invalid]="isControlInvalid('phone')"
                                    [class.is-valid]="isControlValid('phone')">
                                <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'phone')">
                                    This field is required</h5>
                            </div>

                            <div class="form-group">
                                <label>Message</label>
                                <textarea type="text" class="form-control input" formControlName="message"
                                    [class.is-invalid]="isControlInvalid('message')"
                                    [class.is-valid]="isControlValid('message')"></textarea>
                                <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'message')">
                                    This field is required</h5>
                            </div>

                           <button class="btn btnPrimary"  type="submit">Submit</button> 
                        </form>
                        <div class="text-center" style="color: white;" *ngIf="submitted">
                            Thank you for connecting with us. You will hear from us soon!
                        </div>
                </div>
            </div>
        </div>            
    </div>
</div>


<div class="bgWhite py-80">
    <div class="container">
        <h1 class="text-center mb-5" style="color: #f78e41;" [innerHtml]="getInvolvedHeading"></h1>
        
        <div class="row">
            <div class="col-12 col-md-12 col-lg-8 mb-3 mb-lg-0" [innerHtml]="getInvolvedContent">
                
            </div>
            <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
                <div class="embed-responsive embed-responsive-16by9">
                    <iframe [src]="securityByPass('https://www.youtube.com/embed/'+getInvolvedYoutubeId)" 
                    allowfullscreen width="500px"></iframe>
                  </div>
            </div>
        </div>
       
    </div>
</div>

<div class="bgDark py-80">
    <div class="container">
        <h1 class="colorWhite text-center">Social Media</h1>
        <h2 class="colorWhite text-center mb-5">Keep up-to-date with the latest sermons and announcement</h2>
        <div class="row justify-content-around">
            <div class="col-12 col-md-6 col-lg-4 mb-5 mb-lg-0">
                <a href="https://www.youtube.com/channel/UCxUxdO1yCf_TFJzjThBY_DA " title="CrossWind Community Church - Youtube Channel" class="socialMediaBox">
                    <div class="icon"><img src="./../../../assets/images/icyoutubelg.png" /></div>
                    <div class="title text-center">Subscribe to our channel</div>
                </a>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-5 mb-lg-0">
                <a href="https://www.facebook.com/crosswindcommunitychurchdenver/" title="CrossWind Community Church - Facebook Page" class="socialMediaBox">
                    <div class="icon"><img src="./../../../assets/images/icfacebooklg.png" /></div>
                    <div class="title text-center"> Follow our page</div>
                </a>
            </div>
        </div>
    </div>
</div>